const wowApp = require('angular').module('wowApp.shop');

wowApp.component('wowSimplePrice', require('./simple-price.component').simplePriceControllerComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/simpleprice/index.js